/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Fri Feb 24 2023
 **/

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Configure } from "@/frameworks/libraries/utilities";

interface NavigatoreInterface {
	onSuccess?: Callback;
	onFailure?: Callback;
	condition?: (() => boolean) | boolean;
}

export default function useXRMNavigate() {
	const { id } = useParams();
	const [params] = useSearchParams();
	const navigate = useNavigate();

	return {
		navigate,
		guestToLoginView(args?: NavigatoreInterface) {
			const { onSuccess = null, onFailure = null, condition = true } = args || {};
			// condition이 true이면 login페이지로 이동
			let result = true;
			const _condition = typeof condition === "function" ? condition() : condition;
			if (!Configure.is_authenticated && _condition) {
				navigate("/login", { replace: true });
				result = false;
				onSuccess && onSuccess();
				return result;
			}
			onFailure && onFailure();
			return result;
		},
		navigateTo(mode: string) {
			const newParams: { [key: string]: any } = {};
			params.forEach((value, key) => (newParams[key] = value));

			const state = { mode, id, params: newParams };
			// auth 키가 없을 경우 로그인 후 넘어가야 함.
			// TODO 로그인 되어 있을 경우 해당 페이지로 넘어가거나 리턴 후 changeSpace()를 호출해야 함
			navigate(`/${!Configure.is_authenticated ? "login" : ""}`, { state, replace: true });

			return state;
		}
	};
}
